export const SPAN_DATA_NAME = {
  SELECTED_SEARCH_TERM: 'selected-search',
  SELECTED_ENTITY: 'selected-entity',
};
